import { Box, IconButton, Image } from '@chakra-ui/react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import caretDown from '../assets/images/app-switcher-caret-base.svg'
import { useAuth } from '../context/AuthContext'
import { useApp } from '../hooks/useApp'
import { useGetAvailableApps } from '../utils/availableApps'
import { getCurrentAppLogo } from '../utils/getCurrentAppLogo'
import { Card, CardBody } from './Card'
import { EnvironmentBadge } from './EnvironmentBadge'

export const AppSwitcher = () => {
  const [isOpened, setIsOpened] = useState(false)
  const { app } = useApp()
  const { user } = useAuth() ?? {}
  const currentApp = app === 'carkulka-extra' ? 'carkulka' : app!

  const availableApps = useGetAvailableApps()
  const currentAppObject = availableApps.find((app) => app.id === currentApp)

  let otherApps = availableApps
    .filter((app) => app.id !== currentApp)
    .filter((app) => ['carkulka', 'chaloupka', 'cestovko', 'sme'].includes(app.id))

  if (!user?.vehicleRights) otherApps = otherApps.filter(app => app.id != 'carkulka' && app.id != 'carkulka-extra')
  if (!user?.propertyRights) otherApps = otherApps.filter(app => app.id != 'chaloupka')
  if (!user?.travelRights) otherApps = otherApps.filter(app => app.id != 'cestovko')

  const logo = getCurrentAppLogo({ app: currentApp })
  const logoWidth = 'auto'
  const logoHeight = '32px'

  const handleClick = () => setIsOpened(!isOpened)
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center',
        gap: 1,
        position: 'relative',
      }}
    >
      <Link to={currentAppObject?.linkProps?.to || '/'}>
        <Image src={logo} alt={currentApp} width={logoWidth} height={logoHeight} />
      </Link>

      <EnvironmentBadge />

      <Box
        sx={{
          display: isOpened ? 'grid' : ' none',
          position: 'absolute',
          top: 'calc(100% + 0.5rem)',
          left: 0,
          zIndex: 'appSwitcher',
        }}
      >
        <Card>
          <CardBody sx={{ p: 3, gap: 1, shadow: 'lg' }}>
            {Array.isArray(otherApps) &&
              otherApps.map((app) => {

                return (
                  <IconButton
                    colorScheme="whiteAlpha"
                    sx={{ display: 'grid', p: 2, justifyContent: 'start' }}
                    aria-label={app.name}
                    key={app.id}
                    onClick={handleClick}
                    {...app.linkProps}
                  >
                    <Image
                      src={getCurrentAppLogo({ app: app.id })}
                      alt={app.name}
                      style={{ maxWidth: 'none' }}
                      height={logoHeight}
                    />
                  </IconButton>
                )
              })}
          </CardBody>
        </Card>
      </Box>

      {otherApps.length >= 1 &&
        <IconButton
          type="button"
          colorScheme="white"
          aria-label={isOpened ? 'Zavřít výběr aplikací' : 'Otevřít výběr aplikací'}
          onClick={handleClick}
          sx={{ w: 6, h: 6 }}
        >
          <Image
            src={caretDown}
            alt=""
            width="1rem"
            height="1rem"
            sx={{ transform: isOpened ? 'rotate(0deg)' : 'rotate(90deg)' }}
          />
        </IconButton>
      }
    </Box>
  )
}
